import { cn } from "@/lib/utils";

interface ServiceLevelCardProps {
  title: string;
  benefits: string[];
  cta: string;
  onClick: () => void;
  recommended?: boolean;
}

export function ServiceLevelCard({
  title,
  benefits,
  cta,
  onClick,
  recommended = false,
}: ServiceLevelCardProps) {
  return (
    <div
      className={cn(
        "group relative p-12 md:p-16 lg:p-20 space-y-10",
        "bg-secondary/20 rounded-3xl",
        "hover:bg-secondary/30",
        "transition-all duration-300",
        recommended && "bg-primary/5 hover:bg-primary/10"
      )}
    >
      {recommended && (
        <p className="text-xs uppercase tracking-wider text-primary text-center font-medium mb-4">
          Recomendado
        </p>
      )}
      
      <div className="text-center space-y-10">
        <h3 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-tight">{title}</h3>
        
        <div className="space-y-5 pt-4">
          {benefits.map((benefit, index) => (
            <p key={index} className="text-xl md:text-2xl font-light text-muted-foreground leading-relaxed">
              {benefit}
            </p>
          ))}
        </div>
      </div>
      
      <button
        onClick={onClick}
        className={cn(
          "w-full py-6 text-xl md:text-2xl font-light tracking-wide",
          "transition-colors duration-200",
          recommended 
            ? "text-primary hover:text-primary/80" 
            : "text-foreground hover:text-primary"
        )}
      >
        {cta}
      </button>
    </div>
  );
}
